export default {"src":"/_next/static/media/hyperliquid.3dafe2fd.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};